var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDefaultPic = function SvgDefaultPic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#default_pic_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#C0D2E7",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ADB1B8",
    fillRule: "evenodd",
    d: "M8.54 10.53c1.011 0 1.831-.846 1.831-1.89s-.82-1.89-1.832-1.89-1.832.846-1.832 1.89.82 1.89 1.832 1.89m-.618 1.295c.211-.345.554-.345.766 0l1.595 2.604 3.3-5.32c.214-.345.56-.346.774 0l4.663 7.518c.214.344.09.623-.277.623H5.26c-.367 0-.493-.28-.281-.625z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "default_pic_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgDefaultPic;